/**
 * Wrappers tipados para /api/empresa — gestión de empresa y equipo de trabajo.
 * Solo accesible para role='owner'.
 */

import { apiClient } from './apiClient'

export type EmpresaDatos = {
  id: number
  company_name: string
  legal_name: string | null
  rfc: string | null
  postal_code: string | null
  logo_path: string | null
}

export type TeamMember = {
  id: number
  email: string
  first_name: string
  last_name_paternal: string
  last_name_maternal: string | null
  role: 'owner' | 'technician'
  active: boolean
  last_login_at: string | null
  created_at: string
}

export type EmpresaResponse = {
  empresa: EmpresaDatos
  equipo: TeamMember[]
  plan_limits: {
    max_users: number
    current_users: number
  }
}

export type TeamResponse = {
  items: TeamMember[]
  current_users: number
  max_users: number
}

export type InvitePayload = {
  email: string
  first_name?: string
  last_name_paternal?: string
  last_name_maternal?: string
}

export const empresaClient = {
  show: () => apiClient.get<EmpresaResponse>('/empresa'),

  updateDatos: (payload: Partial<Pick<EmpresaDatos, 'company_name' | 'legal_name' | 'rfc' | 'postal_code'>>) =>
    apiClient.patch<{ empresa: EmpresaDatos }>('/empresa/datos', payload),

  getEquipo: () => apiClient.get<TeamResponse>('/empresa/equipo'),

  inviteMember: (payload: InvitePayload) =>
    apiClient.post<{ member: TeamMember }>('/empresa/equipo/invite', payload),

  removeMember: (userId: number) =>
    apiClient.delete<void>(`/empresa/equipo/${userId}`),
}
